
// ─────────────────────────────────────────────────────────
// Sections
// ─────────────────────────────────────────────────────────

function Hero({
  headline,
  sub,
  layout,
  tweaks
}) {
  return /*#__PURE__*/React.createElement("section", {
    className: "section hero",
    "data-screen-label": "01 Hero",
    "data-hero": layout
  }, /*#__PURE__*/React.createElement("div", {
    className: "container hero-inner"
  }, /*#__PURE__*/React.createElement("div", null,  /*#__PURE__*/React.createElement("h1", {
    className: "display-xl",
    "data-comment-anchor": "hero-headline",
    style: {
      fontFamily: "DM Sans"
    }
  }, headline), /*#__PURE__*/React.createElement("p", {
    className: "lede",
    style: {
      fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif"
    }
  }, "Without wasting time searching for scripts. Without complicating props. Without 8-week rehearsal cycles. Without needing to plan. Everything your drama ministry needs \u2014 delivered to your inbox in the next 5 minutes."), /*#__PURE__*/React.createElement("div", {
    className: "cta-row"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://shop.godsverse.org/cart/add?id=64635765588317&selling_plan=691264356701&return_to=/cart",
    className: "btn primary lg"
  }, "Join for $99 ", /*#__PURE__*/React.createElement("span", {
    className: "arrow"
  }, "\u2192")), /*#__PURE__*/React.createElement("a", {
    href: "#what-you-get",
    className: "btn ghost lg"
  }, "See what's inside")), /*#__PURE__*/React.createElement("div", {
    className: "risk-badges"
  }, /*#__PURE__*/React.createElement("span", {
    className: "risk-badge"
  }, /*#__PURE__*/React.createElement("span", {
    className: "ck"
  }, "\u2713"), " 30-day guarantee"), /*#__PURE__*/React.createElement("span", {
    className: "risk-badge"
  }, /*#__PURE__*/React.createElement("span", {
    className: "ck"
  }, "\u2713"), " Cancel anytime"), /*#__PURE__*/React.createElement("span", {
    className: "risk-badge"
  }, /*#__PURE__*/React.createElement("span", {
    className: "ck"
  }, "\u2713"), " Instant access")), /*#__PURE__*/React.createElement("div", {
    className: "hero-proof"
  }, /*#__PURE__*/React.createElement("a", {
    className: "hero-proof-stack", href: "#testimonials-section", style: { textDecoration: "none" }
  }, /*#__PURE__*/React.createElement("div", {
    className: "hero-proof-avatars"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hp-av",
    style: {
      background: "oklch(0.55 0.12 30)"
    }
  }, "MW"), /*#__PURE__*/React.createElement("div", {
    className: "hp-av",
    style: {
      background: "oklch(0.5 0.13 280)"
    }
  }, "TB"), /*#__PURE__*/React.createElement("div", {
    className: "hp-av",
    style: {
      background: "oklch(0.55 0.14 60)"
    }
  }, "DM"), /*#__PURE__*/React.createElement("div", {
    className: "hp-av",
    style: {
      background: "oklch(0.45 0.1 150)"
    }
  }, "LO"), /*#__PURE__*/React.createElement("div", {
    className: "hp-av",
    style: {
      background: "oklch(0.5 0.12 200)"
    }
  }, "JP")), /*#__PURE__*/React.createElement("div", {
    className: "hero-proof-meta"
  }, /*#__PURE__*/React.createElement("div", {
    className: "stars",
    style: {
      color: "var(--gold)",
      letterSpacing: 2
    }
  }, "\u2605\u2605\u2605\u2605\u2605"), /*#__PURE__*/React.createElement("div", {
    className: "hero-proof-line"
  }, /*#__PURE__*/React.createElement("strong", null, "4.9 / 5"), " from 2,000+ church drama directors"))))), /*#__PURE__*/React.createElement("div", {
    className: "video-shell",
    id: "hero-video"
  }, /*#__PURE__*/React.createElement("iframe", {
    src: "https://www.youtube.com/embed/WEqq3Mw1TCk?rel=0",
    title: "Welcome from the founder",
    frameBorder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
    allowFullScreen: true,
    style: {
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      border: 0
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hero-stats"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "num"
  }, "1,000+"), /*#__PURE__*/React.createElement("div", {
    className: "lbl"
  }, "Skits & Plays")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "num"
  }, "2,000+"), /*#__PURE__*/React.createElement("div", {
    className: "lbl"
  }, "CHURCH BACKGROUNDS")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "num"
  }, "50"), /*#__PURE__*/React.createElement("div", {
    className: "lbl"
  }, "REHEARSAL-READY SKITS IN APP")), /*#__PURE__*/React.createElement("div", {
    className: "bonus"
  }, /*#__PURE__*/React.createElement("div", {
    className: "num"
  }, "BONUS \u21161"), /*#__PURE__*/React.createElement("div", {
    className: "lbl"
  }, "Skit Calendar Planner")), /*#__PURE__*/React.createElement("div", {
    className: "bonus"
  }, /*#__PURE__*/React.createElement("div", {
    className: "num"
  }, "BONUS \u21162"), /*#__PURE__*/React.createElement("div", {
    className: "lbl"
  }, "Directing Church Skits 101")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "num"
  }, "$36,788.49"), /*#__PURE__*/React.createElement("div", {
    className: "lbl"
  }, "Total Bundle Value")))));
}
function FirstHundredBanner() {
  return /*#__PURE__*/React.createElement("div", {
    className: "utility"
  }, /*#__PURE__*/React.createElement("span", {
    className: "pulse"
  }), "First 100 members only \xB7 $99/yr (regularly $199) \xB7 You will not see this offer again");
}
function ChurchLogosBar() {
  return /*#__PURE__*/React.createElement("div", {
    className: "logo-bar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "logo-bar-label"
  }, "Trusted by drama directors at 2,000+ churches")));
}
function HowItWorks() {
  const steps = [{
    n: "01",
    t: "Sign up in 60 seconds",
    p: "One annual price. Instant account. No drip campaign."
  }, {
    n: "02",
    t: "Download the calendar tonight",
    p: "Pick the next 3 occasions you want to perform — Easter, Mother's Day, Pentecost."
  }, {
    n: "03",
    t: "Hand scripts to your team",
    p: "Every actor downloads the LordsLines app and rehearses at home with AI reading the other parts."
  }, {
    n: "04",
    t: "Show up Sunday and direct",
    p: "Watch your team do it for real — and your pastor will be the first to brag about you on the way out."
  }];
  return /*#__PURE__*/React.createElement("section", {
    className: "section how-it-works",
    "data-screen-label": "02 How It Works"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section-head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "left"
  }, /*#__PURE__*/React.createElement("span", {
    className: "num"
  }, "\xA7 01"), /*#__PURE__*/React.createElement("span", {
    className: "eyebrow"
  }, "From sign-up to standing ovation")), /*#__PURE__*/React.createElement("div", {
    className: "right"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "display-l"
  }, "Four steps. Zero overwhelm."), /*#__PURE__*/React.createElement("p", {
    className: "lede"
  }, "Most drama ministries are stuck in week-of panic. Here's how Pro Membership replaces that with a clean, repeatable rhythm."))), /*#__PURE__*/React.createElement("div", {
    className: "hiw-grid"
  }, steps.map(s => /*#__PURE__*/React.createElement("div", {
    className: "hiw-step",
    key: s.n
  }, /*#__PURE__*/React.createElement("div", {
    className: "hiw-num"
  }, s.n), /*#__PURE__*/React.createElement("h4", null, s.t), /*#__PURE__*/React.createElement("p", null, s.p))))));
}
function WhatYouGet() {
  return /*#__PURE__*/React.createElement("section", {
    className: "section cream-2",
    id: "what-you-get",
    "data-screen-label": "02 What You Get"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section-head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "left"
  }, /*#__PURE__*/React.createElement("span", {
    className: "num"
  }, "\xA7 02"), /*#__PURE__*/React.createElement("span", {
    className: "eyebrow"
  }, "Inside the Membership")), /*#__PURE__*/React.createElement("div", {
    className: "right"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "display-l"
  }, "Five things land in your inbox the moment you join."), /*#__PURE__*/React.createElement("p", {
    className: "lede"
  }, "No drip campaign. No \"unlocks over time.\" You get the full library, the app, the course, the backgrounds, and the calendar \u2014 today."))), /*#__PURE__*/React.createElement("div", {
    className: "deliverables"
  }, /*#__PURE__*/React.createElement("div", {
    className: "left"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "total-value"
  }, "TOTAL VALUE \xB7 $36,788.49"), /*#__PURE__*/React.createElement("div", {
    className: "price-stack",
    style: {
      padding: "30px 0px 0px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "price-now"
  }, "$99"), /*#__PURE__*/React.createElement("div", {
    className: "price-was"
  }, "$199")), /*#__PURE__*/React.createElement("div", {
    className: "price-period",
    style: {
      margin: "13px 0px 0px"
    }
  }, "/ year \xB7 billed annually")), /*#__PURE__*/React.createElement("ul", {
    className: "assurance"
  }, /*#__PURE__*/React.createElement("li", null, "30-day money-back guarantee"), /*#__PURE__*/React.createElement("li", null, "Cancel anytime \u2014 one click"), /*#__PURE__*/React.createElement("li", null, "Instant access \xB7 download today"), /*#__PURE__*/React.createElement("li", null, "Use across your whole drama team")), /*#__PURE__*/React.createElement("a", {
    href: "https://shop.godsverse.org/cart/add?id=64635765588317&selling_plan=691264356701&return_to=/cart",
    className: "btn primary"
  }, "Join for $99 ", /*#__PURE__*/React.createElement("span", {
    className: "arrow"
  }, "\u2192"))), /*#__PURE__*/React.createElement("div", {
    className: "right"
  }, DELIVERABLES.map(d => /*#__PURE__*/React.createElement("div", {
    className: "deliverable-row",
    key: d.n
  }, /*#__PURE__*/React.createElement("div", {
    className: "num"
  }, d.n), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, d.title), /*#__PURE__*/React.createElement("p", null, d.desc)), /*#__PURE__*/React.createElement("div", {
    className: "value"
  }, d.value)))))));
}
function Calendar() {
  return /*#__PURE__*/React.createElement("section", {
    className: "section",
    "data-screen-label": "03 Calendar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section-head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "left"
  }, /*#__PURE__*/React.createElement("span", {
    className: "num"
  }, "\xA7 03"), /*#__PURE__*/React.createElement("span", {
    className: "eyebrow"
  }, "Will I use it enough?")), /*#__PURE__*/React.createElement("div", {
    className: "right"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "display-l"
  }, "Here are ", /*#__PURE__*/React.createElement("em", {
    className: "serif-italic"
  }, "15 occasions"), " a typical church performs drama."), /*#__PURE__*/React.createElement("p", {
    className: "lede"
  }, "We mapped a whole year for you. Print the PDF, pin it to the wall, and you'll never wonder what to put on stage next month again."))), /*#__PURE__*/React.createElement("div", {
    className: "calendar-frame"
  }, /*#__PURE__*/React.createElement("div", {
    className: "head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, "The 2026 Drama Calendar"), /*#__PURE__*/React.createElement("div", {
    className: "meta"
  }, "PDF \xB7 Delivered in email #1")), /*#__PURE__*/React.createElement("div", {
    className: "calendar-grid"
  }, CALENDAR.map((c, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    className: `cal-month has-event ${c.major ? "major" : ""}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "m"
  }, c.m), /*#__PURE__*/React.createElement("div", {
    className: "e"
  }, c.e, /*#__PURE__*/React.createElement("small", null, c.sub)))), /*#__PURE__*/React.createElement("div", {
    className: "cal-month",
    style: {
      background: "transparent"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "m",
    style: {
      color: "var(--rule-strong)"
    }
  }, "+more"), /*#__PURE__*/React.createElement("div", {
    className: "e",
    style: {
      color: "var(--muted)",
      fontSize: 14,
      fontFamily: "var(--mono)",
      textTransform: "uppercase",
      letterSpacing: "0.12em"
    }
  }, "Plus weekly Sunday service skits & youth nights"))), /*#__PURE__*/React.createElement("div", {
    className: "foot"
  }, /*#__PURE__*/React.createElement("span", null, "15 occasions \xB7 12 months \xB7 1 PDF"), /*#__PURE__*/React.createElement("span", null, "\u2605 Major productions")))));
}
function AppDemo() {
  return /*#__PURE__*/React.createElement("section", {
    className: "section cream-2",
    "data-screen-label": "04 App Demo"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section-head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "left"
  }, /*#__PURE__*/React.createElement("span", {
    className: "num"
  }, "\xA7 04"), /*#__PURE__*/React.createElement("span", {
    className: "eyebrow"
  }, "LordsLines Pro \xB7 included")), /*#__PURE__*/React.createElement("div", {
    className: "right"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "display-l"
  }, "Cut rehearsal time in half. Your team practices at home."), /*#__PURE__*/React.createElement("p", {
    className: "lede"
  }, "Pick a skit. Choose your role. AI reads every other part aloud \u2014 so actors show up to rehearsal already knowing their lines."))), /*#__PURE__*/React.createElement("div", {
    className: "app-shots"
  }, [{
    src: window.__resources && window.__resources.appShot1 || "assets/app-1-pick-skit.png",
    step: "01",
    title: "Pick a Skit"
  }, {
    src: window.__resources && window.__resources.appShot2 || "assets/app-2-pick-role.png",
    step: "02",
    title: "Pick Your Role"
  }, {
    src: window.__resources && window.__resources.appShot3 || "assets/app-3-practice-mode.png",
    step: "03",
    title: "Enter Practice Mode"
  }, {
    src: window.__resources && window.__resources.appShot4 || "assets/app-4-ai-reads.png",
    step: "04",
    title: "AI Reads Other Parts"
  }, {
    src: window.__resources && window.__resources.appShot5 || "assets/app-5-practice-lines.png",
    step: "05",
    title: "Practice Your Lines"
  }].map((s, i) => /*#__PURE__*/React.createElement("figure", {
    className: "app-shot",
    key: i
  }, /*#__PURE__*/React.createElement("div", {
    className: "app-shot-num"
  }, s.step), /*#__PURE__*/React.createElement("img", {
    src: s.src,
    alt: s.title,
    loading: "lazy"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "app-shot-foot"
  }, "On the bus, in the car, in your kitchen at 11pm \u2014 your team shows up to rehearsal already knowing their lines.", /*#__PURE__*/React.createElement("span", null, "iPhone available now \xB7 Android in closed testing"))));
}
function ShopifyCollection() {
  const ref = React.useRef(null);
  React.useEffect(() => {
    if (!ref.current || ref.current.dataset.inited) return;
    ref.current.dataset.inited = "1";
    const init = () => {
      const client = window.ShopifyBuy.buildClient({
        domain: "xvrw11-qm.myshopify.com",
        storefrontAccessToken: "871cec060740c6419bce00735196494d"
      });
      window.ShopifyBuy.UI.onReady(client).then(ui => {
        ui.createComponent("collection", {
          id: "709867569501",
          node: ref.current,
          moneyFormat: "%24%7B%7Bamount%7D%7D",
          options: {
            product: {
              styles: {
                product: {
                  "@media (min-width: 601px)": {
                    "max-width": "calc(25% - 20px)",
                    "margin-left": "20px",
                    "margin-bottom": "50px",
                    "width": "calc(25% - 20px)"
                  },
                  img: {
                    height: "calc(100% - 15px)",
                    position: "absolute",
                    left: "0",
                    right: "0",
                    top: "0"
                  },
                  imgWrapper: {
                    "padding-top": "calc(75% + 15px)",
                    position: "relative",
                    height: "0"
                  }
                },
                button: {
                  ":hover": {
                    "background-color": "#ad4b36"
                  },
                  "background-color": "#c0533c",
                  ":focus": {
                    "background-color": "#ad4b36"
                  }
                }
              },
              buttonDestination: "modal",
              contents: {
                options: false
              },
              text: {
                button: "View product"
              }
            },
            productSet: {
              styles: {
                products: {
                  "@media (min-width: 601px)": {
                    "margin-left": "-20px"
                  }
                }
              }
            },
            modalProduct: {
              contents: {
                img: false,
                imgWithCarousel: true,
                button: false,
                buttonWithQuantity: true
              },
              styles: {
                product: {
                  "@media (min-width: 601px)": {
                    "max-width": "100%",
                    "margin-left": "0px",
                    "margin-bottom": "0px"
                  }
                },
                button: {
                  ":hover": {
                    "background-color": "#ad4b36"
                  },
                  "background-color": "#c0533c",
                  ":focus": {
                    "background-color": "#ad4b36"
                  }
                }
              },
              text: {
                button: "Add to cart"
              }
            },
            cart: {
              styles: {
                button: {
                  ":hover": {
                    "background-color": "#ad4b36"
                  },
                  "background-color": "#c0533c",
                  ":focus": {
                    "background-color": "#ad4b36"
                  }
                }
              },
              text: {
                total: "Subtotal",
                button: "Checkout"
              }
            },
            toggle: {
              styles: {
                toggle: {
                  "background-color": "#c0533c",
                  ":hover": {
                    "background-color": "#ad4b36"
                  },
                  ":focus": {
                    "background-color": "#ad4b36"
                  }
                }
              }
            }
          }
        });
      });
    };
    if (window.ShopifyBuy && window.ShopifyBuy.UI) {
      init();
      return;
    }
    const existing = document.querySelector('script[src*="buy-button-storefront"]');
    if (existing) {
      existing.addEventListener("load", init);
      return;
    }
    const s = document.createElement("script");
    s.async = true;
    s.src = "https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js";
    s.onload = init;
    document.head.appendChild(s);
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: "shopify-collection-mount"
  });
}
function SkitPreviews() {
  return /*#__PURE__*/React.createElement("section", {
    className: "section",
    "data-screen-label": "05 Skit Previews"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section-head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "left"
  }, /*#__PURE__*/React.createElement("span", {
    className: "num"
  }, "\xA7 05"), /*#__PURE__*/React.createElement("span", {
    className: "eyebrow"
  }, "THE SKITS")), /*#__PURE__*/React.createElement("div", {
    className: "right"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "display-l"
  }, "A taste of what's inside the library."), /*#__PURE__*/React.createElement("p", {
    className: "lede"
  }, "1,000+ skits, plays, and dramatic pieces \u2014 with new ones added monthly. A few examples are below, but as a Pro Member you get the full library."))), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 56
    }
  }, /*#__PURE__*/React.createElement(ShopifyCollection, null))));
}
function Course() {
  return /*#__PURE__*/React.createElement("section", {
    className: "section dark",
    "data-screen-label": "06 Course"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section-head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "left"
  }, /*#__PURE__*/React.createElement("span", {
    className: "num on-ink",
    style: {
      color: "var(--muted-on-ink)"
    }
  }, "\xA7 06"), /*#__PURE__*/React.createElement("span", {
    className: "eyebrow on-ink"
  }, "Directing Skits 101")), /*#__PURE__*/React.createElement("div", {
    className: "right"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "display-l"
  }, "Direct your next skit like a pro \u2014 in 100 minutes."), /*#__PURE__*/React.createElement("p", {
    className: "lede"
  }, "A practical video course that hands you the unwritten playbook every drama director eventually figures out the hard way \u2014 and saves you years of rehearsal-room mistakes."))), /*#__PURE__*/React.createElement("div", {
    className: "curriculum"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "course-preview"
  }, /*#__PURE__*/React.createElement("iframe", {
    src: "https://www.youtube.com/embed/oEzA8qarg1A?rel=0",
    title: "Directing Church Skits 101",
    frameBorder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "course-meta"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "v"
  }, "9"), /*#__PURE__*/React.createElement("div", {
    className: "l"
  }, "Modules")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "v"
  }, "\u221E"), /*#__PURE__*/React.createElement("div", {
    className: "l"
  }, "Lifetime Access")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "v"
  }, "$0"), /*#__PURE__*/React.createElement("div", {
    className: "l"
  }, "Extra Cost")))), /*#__PURE__*/React.createElement("div", {
    className: "modules"
  }, MODULES.map(m => /*#__PURE__*/React.createElement("div", {
    className: "module",
    key: m.n
  }, /*#__PURE__*/React.createElement("div", {
    className: "num"
  }, m.n), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", null, m.t), /*#__PURE__*/React.createElement("p", null, m.p))))))));
}
const BG_COLLECTIONS = [{
  title: "Clean Minimalist",
  slug: "clean-minimalist",
  count: 201, image: "https://shop.godsverse.org/cdn/shop/collections/clean_minimalist_BG01_Blank_HD_151dcbf4-4056-49ab-b6a4-99b9c4023fb3.jpg"
}, {
  title: "Cross Light",
  slug: "cross-light",
  count: 173, image: "https://shop.godsverse.org/cdn/shop/collections/cross_light_BG01_Blank_HD_0800c282-c9d4-4ab6-a777-a5b357e97261.jpg"
}, {
  title: "Deep Space",
  slug: "deep-space",
  count: 181, image: "https://shop.godsverse.org/cdn/shop/collections/deep_space_BG01_Blank_HD_b8e0f2ca-8e0f-4f86-9b54-98dd8449b8dc.jpg"
}, {
  title: "Easter Collection",
  slug: "easter-collection",
  count: 203, image: "https://shop.godsverse.org/cdn/shop/collections/easter_collection_BG01_Blank_HD_552da0a4-d39c-4ece-bf8c-999daf39c318.jpg"
}, {
  title: "Ember Flame",
  slug: "ember-flame",
  count: 183, image: "https://shop.godsverse.org/cdn/shop/collections/ember_flame_BG01_Blank_HD_0c6dd07b-890d-40f4-a5e9-8b02d1a1c03b.jpg"
}, {
  title: "Geometric Worship",
  slug: "geometric-worship",
  count: 203, image: "https://shop.godsverse.org/cdn/shop/collections/geometric_worship_collage.jpg"
}, {
  title: "Golden Hour Glow",
  slug: "golden-hour-glow",
  count: 241, image: "https://shop.godsverse.org/cdn/shop/collections/BG_01_Blank_HD.jpg"
}, {
  title: "Heavenly Clouds",
  slug: "heavenly-clouds",
  count: 223, image: "https://shop.godsverse.org/cdn/shop/collections/heavenly_clouds_BG01_Blank_HD_826d5607-3493-4209-8920-a2e45440d0b5.jpg"
}, {
  title: "Light Leak Flare",
  slug: "light-leak-flare",
  count: 163, image: "https://shop.godsverse.org/cdn/shop/collections/light_leak_flare_BG03_Blank_HD_a07d3512-34b8-4b36-ab14-e3ae19238922.jpg"
}, {
  title: "Living Water",
  slug: "living-water",
  count: 111, image: "https://shop.godsverse.org/cdn/shop/collections/living_water_BG02_Blank_HD_680c37f5-3dfe-4d06-89b1-7ee8d146789b.jpg"
}, {
  title: "Mountain Majesty",
  slug: "mountain-majesty",
  count: 193, image: "https://shop.godsverse.org/cdn/shop/collections/mountain_majesty_BG08_Blank_HD_4ba5cdb6-4bd0-4c3c-88de-bc121fff3591.jpg"
}, {
  title: "Particle Worship",
  slug: "particle-worship",
  count: 213, image: "https://shop.godsverse.org/cdn/shop/collections/particle_worship_BG01_Blank_HD_7cc306ff-dcb5-4666-a096-eb91f79cdf4f.jpg"
}, {
  title: "Soft Bokeh",
  slug: "soft-bokeh",
  count: 253, image: "https://shop.godsverse.org/cdn/shop/collections/soft_bokeh_BG01_Blank_HD_aaac39f8-aa50-4aec-9a20-1be646cf22df.jpg"
}, {
  title: "Stained Glass",
  slug: "stained-glass",
  count: 161, image: "https://shop.godsverse.org/cdn/shop/collections/stained_glass_BG05_Blank_HD_a13bb1b7-0076-47a7-b599-2e4782300d17.jpg"
}, {
  title: "Urban Concrete",
  slug: "urban-concrete",
  count: 153, image: "https://shop.godsverse.org/cdn/shop/collections/urban_concrete_BG02_Blank_4K_ce96767d-3136-43e7-b515-694491e96227.jpg"
}, {
  title: "Watercolor Worship",
  slug: "watercolor-worship",
  count: 213, image: "https://shop.godsverse.org/cdn/shop/collections/watercolor_worship_BG01_Blank_HD_4371a18b-8656-4914-baa5-b869d9d662df.jpg"
}];
function Backgrounds() {
  return /*#__PURE__*/React.createElement("section", {
    className: "section cream-2",
    "data-screen-label": "07 Backgrounds"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section-head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "left"
  }, /*#__PURE__*/React.createElement("span", {
    className: "num"
  }, "\xA7 07"), /*#__PURE__*/React.createElement("span", {
    className: "eyebrow"
  }, "Backgrounds & Motions")), /*#__PURE__*/React.createElement("div", {
    className: "right"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "display-l"
  }, "Make your stage look like a megachurch \u2014 without the megachurch budget."), /*#__PURE__*/React.createElement("p", {
    className: "lede"
  }, "Welcome loops, sermon backgrounds, countdown timers, scripture stills. The full Godsverse worship visuals collection, dropped into your account on day one."))), /*#__PURE__*/React.createElement("div", {
    className: "bg-gallery"
  }, BG_COLLECTIONS.map((c, i) => /*#__PURE__*/React.createElement("a", {
    className: `bg-tile b${i % 12 + 1}`,
    href: `https://shop.godsverse.org/collections/${c.slug}`,
    target: "_blank",
    rel: "noopener",
    key: c.slug,
    style: c.image ? {
      backgroundImage: `linear-gradient(to top, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.15) 50%, rgba(0,0,0,0.05) 100%), url(${c.image})`,
      backgroundSize: "cover",
      backgroundPosition: "center"
    } : undefined
  }, /*#__PURE__*/React.createElement("span", {
    className: "tag"
  }, c.title), /*#__PURE__*/React.createElement("span", {
    className: "bg-count"
  }, c.count, " backgrounds")))), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 32,
      textAlign: "center",
      fontFamily: "var(--mono)",
      fontSize: 11,
      letterSpacing: "0.12em",
      textTransform: "uppercase",
      color: "var(--muted)"
    }
  }, "16 collections \xB7 2,000+ assets \xB7 1080p & 4K \xB7 ProPresenter / EasyWorship / Keynote ready")));
}
function Testimonials() {
  return /*#__PURE__*/React.createElement("section", {
    className: "section",
    id: "testimonials-section",
    "data-screen-label": "08 Testimonials"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section-head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "left"
  }, /*#__PURE__*/React.createElement("span", {
    className: "num"
  }, "\xA7 08"), /*#__PURE__*/React.createElement("span", {
    className: "eyebrow"
  }, "Loved by 2,000+ churches")), /*#__PURE__*/React.createElement("div", {
    className: "right"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "display-l"
  }, "\"I am excited to see what God will do through this skit.\""), /*#__PURE__*/React.createElement("p", {
    className: "lede"
  }, "Real, verified reviews from drama directors, pastors, and volunteers who performed scripts from the library this year."))), /*#__PURE__*/React.createElement("div", {
    className: "testimonials-grid"
  }, TESTIMONIALS.map((t, i) => t.format === "email" ? /*#__PURE__*/React.createElement("div", {
    className: "testimonial email",
    key: i
  }, /*#__PURE__*/React.createElement("div", {
    className: "email-head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "email-from"
  }, /*#__PURE__*/React.createElement("div", {
    className: "avatar"
  }, t.initials), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "name"
  }, t.name), /*#__PURE__*/React.createElement("div", {
    className: "email-meta"
  }, "to support@godsverse.org"))), /*#__PURE__*/React.createElement("div", {
    className: "email-tag"
  }, "\u2605 5-star email")), /*#__PURE__*/React.createElement("div", {
    className: "email-subject"
  }, t.subject), /*#__PURE__*/React.createElement("blockquote", null, t.quote), /*#__PURE__*/React.createElement("div", {
    className: "email-foot"
  }, t.role)) : /*#__PURE__*/React.createElement("div", {
    className: "testimonial",
    key: i
  }, /*#__PURE__*/React.createElement(Stars, {
    n: t.stars
  }), /*#__PURE__*/React.createElement("blockquote", null, "\"", t.quote, "\""), /*#__PURE__*/React.createElement("div", {
    className: "who"
  }, /*#__PURE__*/React.createElement("div", {
    className: "avatar"
  }, t.initials), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "name"
  }, t.name), /*#__PURE__*/React.createElement("div", {
    className: "role"
  }, t.role))))))));
}
function Guarantee() {
  return /*#__PURE__*/React.createElement("section", {
    className: "section tight",
    "data-screen-label": "09 Guarantee"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container narrow"
  }, /*#__PURE__*/React.createElement("div", {
    className: "guarantee"
  }, /*#__PURE__*/React.createElement("div", {
    className: "seal"
  }, /*#__PURE__*/React.createElement("div", {
    className: "num"
  }, "30"), /*#__PURE__*/React.createElement("div", {
    className: "lbl"
  }, "Day Guarantee"), /*#__PURE__*/React.createElement("div", {
    className: "lbl-2"
  }, "Risk-Free")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "eyebrow"
  }, "Try it risk-free"), /*#__PURE__*/React.createElement("h3", {
    className: "display-m",
    style: {
      marginTop: 12
    }
  }, "If it doesn't help your ministry within 30 days, we refund every dollar."), /*#__PURE__*/React.createElement("p", {
    style: {
      marginTop: 14,
      color: "var(--muted)",
      fontSize: 16
    }
  }, "Use the library, watch the course, run a rehearsal with the app. If it's not the right fit, email us inside 30 days and we'll refund you in full \u2014 no forms, no friction. And you can cancel your renewal anytime, one click, from your account.")))));
}
function Founder() {
  return /*#__PURE__*/React.createElement("section", {
    className: "section cream-2",
    "data-screen-label": "10 Founder"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container narrow"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section-head",
    style: {
      marginBottom: 40
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "left"
  }, /*#__PURE__*/React.createElement("span", {
    className: "num"
  }, "\xA7 10"), /*#__PURE__*/React.createElement("span", {
    className: "eyebrow"
  }, "A note from the founder")), /*#__PURE__*/React.createElement("div", {
    className: "right"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "display-m"
  }, "Why we built this."))), /*#__PURE__*/React.createElement("div", {
    className: "founder"
  }, /*#__PURE__*/React.createElement("img", {
    className: "portrait",
    src: window.__resources && window.__resources.productShot || "assets/product-shot.jpeg",
    alt: "Godsverse Scripts on a laptop with the LordsLines Pro app, Drama Calendar PDF, and Directing Church Skits 101 course book on a wooden table inside a sanctuary"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("blockquote", null, "Drama directors kept telling us the same things: \"I can't find scripts that fit my cast.\" \"Volunteers don't show up to rehearsal.\" \"I'm exhausted by the week before Easter.\" So we built the toolkit they wished existed \u2014 every script, every background, the rehearsal app, and the playbook for directing volunteers, in one place, for one fair price."), /*#__PURE__*/React.createElement("div", {
    className: "sig"
  }, "Markos K."), /*#__PURE__*/React.createElement("div", {
    className: "role"
  }, "Founder \xB7 Godsverse")))));
}
function FAQ() {
  return /*#__PURE__*/React.createElement("section", {
    className: "section",
    "data-screen-label": "11 FAQ"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container narrow"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section-head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "left"
  }, /*#__PURE__*/React.createElement("span", {
    className: "num"
  }, "\xA7 11"), /*#__PURE__*/React.createElement("span", {
    className: "eyebrow"
  }, "Questions, answered")), /*#__PURE__*/React.createElement("div", {
    className: "right"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "display-l"
  }, "Before you join."))), /*#__PURE__*/React.createElement("div", {
    className: "faq-list"
  }, FAQS.map((f, i) => /*#__PURE__*/React.createElement("details", {
    className: "faq",
    key: i,
    open: i === 0
  }, /*#__PURE__*/React.createElement("summary", null, f.q, /*#__PURE__*/React.createElement("span", {
    className: "ind"
  }, "+")), f.body ? f.body : /*#__PURE__*/React.createElement("p", null, f.a))))));
}
function FinalCTA() {
  return /*#__PURE__*/React.createElement("section", {
    className: "section dark final-cta",
    id: "join",
    "data-screen-label": "12 Final CTA"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container narrow"
  }, /*#__PURE__*/React.createElement("span", {
    className: "eyebrow on-ink"
  }, "Join today"), /*#__PURE__*/React.createElement("h2", {
    className: "display-xl",
    style: {
      marginTop: 20
    }
  }, "Plan your year. Rehearse from anywhere. ", /*#__PURE__*/React.createElement("em", {
    className: "serif-italic",
    style: {
      color: "var(--gold)"
    }
  }, "Get them off the page.")), /*#__PURE__*/React.createElement("p", {
    className: "lede",
    style: {
      maxWidth: 600,
      marginInline: "auto",
      marginTop: 24
    }
  }, "Everything you need to run a drama ministry \u2014 for less than what most churches pay for a single Easter script bundle."), /*#__PURE__*/React.createElement("div", {
    className: "price-final"
  }, /*#__PURE__*/React.createElement("span", {
    className: "now"
  }, "$99"), /*#__PURE__*/React.createElement("span", {
    className: "was"
  }, "$199"), /*#__PURE__*/React.createElement("span", {
    className: "yr"
  }, "/ year")), /*#__PURE__*/React.createElement("div", {
    className: "first-100"
  }, "\u2605 First 100 members only \xB7 You will not see this offer again"), /*#__PURE__*/React.createElement("a", {
    href: "https://shop.godsverse.org/cart/add?id=64635765588317&selling_plan=691264356701&return_to=/cart",
    className: "btn primary lg"
  }, "Claim my Pro Membership ", /*#__PURE__*/React.createElement("span", {
    className: "arrow"
  }, "\u2192")), /*#__PURE__*/React.createElement("div", {
    className: "micro"
  }, "30-day money-back guarantee \xB7 Cancel anytime \xB7 Instant access")));
}

// ─────────────────────────────────────────────────────────
// Tweaks — exposed via the host edit-mode panel
// ─────────────────────────────────────────────────────────

const HEADLINE_OPTIONS = ["Put on Easter productions your congregation talks about for years.", "Direct skits that make your pastor brag about you.", "Run drama ministry like the megachurch down the road — for $99 a year.", "Get them off the page and onto the stage — without the rehearsal-week panic."];
function App({
  tweaks,
  setTweak
}) {
  // Apply theme to body
  React.useEffect(() => {
    document.body.dataset.theme = tweaks.theme;
  }, [tweaks.theme]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FirstHundredBanner, null), /*#__PURE__*/React.createElement(Hero, {
    headline: tweaks.headline,
    sub: "",
    layout: tweaks.heroLayout
  }), /*#__PURE__*/React.createElement(ChurchLogosBar, null), /*#__PURE__*/React.createElement(HowItWorks, null), /*#__PURE__*/React.createElement(WhatYouGet, null), /*#__PURE__*/React.createElement(Calendar, null), /*#__PURE__*/React.createElement(AppDemo, null), /*#__PURE__*/React.createElement(SkitPreviews, null), /*#__PURE__*/React.createElement(Course, null), /*#__PURE__*/React.createElement(Backgrounds, null), /*#__PURE__*/React.createElement(Testimonials, null), /*#__PURE__*/React.createElement(Guarantee, null), /*#__PURE__*/React.createElement(Founder, null), /*#__PURE__*/React.createElement(FAQ, null), /*#__PURE__*/React.createElement(FinalCTA, null), /*#__PURE__*/React.createElement("footer", null, /*#__PURE__*/React.createElement("span", null, "\xA9 2026 Godsverse \xB7 A product of Godsverse.org"), /*#__PURE__*/React.createElement("span", null, "Editorial \xB7 editorial@godsverse.org")), window.TweaksPanel && /*#__PURE__*/React.createElement(window.TweaksPanel, {
    title: "Tweaks"
  }, /*#__PURE__*/React.createElement(window.TweakSection, {
    title: "Theme"
  }, /*#__PURE__*/React.createElement(window.TweakRadio, {
    label: "Color",
    value: tweaks.theme,
    options: [{
      value: "oxblood",
      label: "Oxblood"
    }, {
      value: "forest",
      label: "Forest"
    }, {
      value: "ink",
      label: "Ink"
    }, {
      value: "sunset",
      label: "Sunset"
    }],
    onChange: v => setTweak("theme", v)
  })), /*#__PURE__*/React.createElement(window.TweakSection, {
    title: "Hero Layout"
  }, /*#__PURE__*/React.createElement(window.TweakRadio, {
    label: "Layout",
    value: tweaks.heroLayout,
    options: [{
      value: "split",
      label: "Split"
    }, {
      value: "centered",
      label: "Centered"
    }],
    onChange: v => setTweak("heroLayout", v)
  })), /*#__PURE__*/React.createElement(window.TweakSection, {
    title: "Headline"
  }, /*#__PURE__*/React.createElement(window.TweakSelect, {
    label: "Preset",
    value: tweaks.headline,
    options: HEADLINE_OPTIONS.map(h => ({
      value: h,
      label: h.length > 50 ? h.slice(0, 48) + "…" : h
    })),
    onChange: v => setTweak("headline", v)
  }), /*#__PURE__*/React.createElement(window.TweakText, {
    label: "Custom",
    value: tweaks.headline,
    onChange: v => setTweak("headline", v),
    multiline: true
  }))));
}

// Boot
function Boot() {
  const TWEAK_DEFAULTS = /*EDITMODE-BEGIN*/{
    "theme": "oxblood",
    "heroLayout": "split",
    "headline": "Start Every Service With a Skit Everyone Talks About."
  } /*EDITMODE-END*/;
  const [tweaks, setTweaksState] = useState(TWEAK_DEFAULTS);
  const setTweak = (key, value) => {
    let edits;
    if (typeof key === "object") edits = key;else edits = {
      [key]: value
    };
    setTweaksState(prev => ({
      ...prev,
      ...edits
    }));
    window.parent.postMessage({
      type: "__edit_mode_set_keys",
      edits
    }, "*");
  };
  return /*#__PURE__*/React.createElement(App, {
    tweaks: tweaks,
    setTweak: setTweak
  });
}
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(/*#__PURE__*/React.createElement(Boot, null));